import { PhotoPosition, normalizePhotoPosition, PHOTO_POSITION_OPTIONS } from "@/lib/avatar";

interface Props {
  value: string | null | undefined;
  onChange: (value: PhotoPosition) => void;
  disabled?: boolean;
}

// Seletor simples (Topo / Centro / Base) do ponto focal da foto de perfil.
// Simples e confiável no celular — três botões, sem arrastar.
export default function PhotoPositionSelector({ value, onChange, disabled = false }: Props) {
  const current = normalizePhotoPosition(value);

  return (
    <div className="flex items-center gap-1 p-1 rounded-full bg-beige/60 border border-nude w-fit">
      {PHOTO_POSITION_OPTIONS.map((opt) => {
        const active = current === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            disabled={disabled}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full font-body text-xs whitespace-nowrap transition-colors cursor-pointer disabled:opacity-50 ${
              active ? "bg-primary text-white" : "text-brown/60 hover:bg-white"
            }`}
          >
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className={`${opt.icon} text-[13px]`} />
            </span>
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}